import React from 'react'
import Div from '../Div'
import './whoweare.scss'

export default function WhoWeAre({variant, title, subtitle1, subtitle2}) {
  return (
    <Div className={variant ? `cs-funfact_wrap ${variant}`: 'cs-funfact_wrap'} data-aos="fade-up" data-aos-duration="2000">
      <Div className="cs-funfact_shape"  style={{backgroundImage: 'url(./images/funfact_shape_bg.svg)'}} />
      <Div className="cs-funfact_left">
        <Div className="cs-funfact_heading">
          <h2>{title}</h2>
          <p>{subtitle1}</p>
          <p>{subtitle2}</p>
        </Div>
      </Div>

    </Div>
  )
}
